const wrapPageElement = ({ element }) => element
export default wrapPageElement
